import {
  CrisalixActions,
  CrisalixUser,
  CrisalixUserList,
  INITIAL_STATE_CRISALIXUSERLIST,
} from 'app/types/crisalix';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useCrisalix = create(
  persist<CrisalixUserList & CrisalixActions>(
    set => ({
      crisalixUser: INITIAL_STATE_CRISALIXUSERLIST.crisalixUser,
      addCrisalixUser: (newUser: CrisalixUser) => {
        set(state => ({
          crisalixUser: [...state.crisalixUser, newUser],
        }));
      },
      removeCrisalixUser: (userRemove: CrisalixUser) => {
        set(state => ({
          crisalixUser: state.crisalixUser.filter(
            user => user.id !== userRemove.id
          ),
        }));
      },
    }),
    {
      name: 'CrisalixUser',
    }
  )
);
